import { useMemo } from 'react';
import {
  NavLinkInterface,
  getBaseNavLinks,
  claimsNavLink,
} from 'models/nav-config.model';

export const useNavLinksList = (showClaims: boolean) => {
  const navLinks = useMemo<NavLinkInterface[]>(() => {
    const baseNavLinks = getBaseNavLinks();
    return showClaims
      ? [...baseNavLinks.slice(0, 3), claimsNavLink, baseNavLinks[3]]
      : baseNavLinks;
  }, [showClaims]);

  return { navLinks };
};
